import {
  Route,
  localePath,
  getRouteBaseName,
  localeRoute,
  localeLocation,
  resolveRoute,
  switchLocalePath,
  localeHead
} from 'vue-i18n-routing';
import router from '@/router';
import { i18n } from '@/locales/index';
// 这routing插件需要RouteProxy 这些参数头大，还不维护了
const routing = {
  i18n: i18n,
  router,
  route: router.cureentRoute,
  getRouteBaseName,
  localePath,
  localeRoute,
  localeLocation,
  resolveRoute,
  switchLocalePath,
  localeHead,
  defaultLocale: router.options.defaultLocale,
  localeCodes: router.options.locales,
  strategy: router.options.strategy,
  defaultDirection: router.options.defaultDirection,
  defaultLocaleRouteNameSuffix: router.options.defaultLocaleRouteNameSuffix,
  trailingSlash: router.options.trailingSlash,
  routesNameSeparator: router.options.routesNameSeparator,
  prefixable: router.options.prefixable,
  switchLocalePathIntercepter: router.options.switchLocalePathIntercepter,
  dynamicRouteParamsKey: router.options.dynamicRouteParamsKey
};
// 编程式路由跳转
export const routerLocalePathProgram = (route: Route, mode: 'replace' | 'push' = 'push') => {
  router[mode](localePath.call(routing, route));
};

// 静态资源地址
export const staticUrl: string = import.meta.env.VITE_APP_STATIC_PATH;
export const staticUrl1: string = import.meta.env.VITE_APP_STATIC_PATH1;
export const staticUrl2: string = import.meta.env.VITE_APP_STATIC_PATH2;
export const staticUrl3: string = import.meta.env.VITE_APP_STATIC_PATH3;
export const staticUrl4: string = import.meta.env.VITE_APP_STATIC_PATH4;
export const staticUrl5: string = import.meta.env.VITE_APP_STATIC_PATH5;
export const staticUrl6: string = import.meta.env.VITE_APP_STATIC_PATH6;
export const staticUrl7: string = import.meta.env.VITE_APP_STATIC_PATH7;
export const staticUrl8: string = import.meta.env.VITE_APP_STATIC_PATH8;
export const staticUrl9: string = import.meta.env.VITE_APP_STATIC_PATH9;
export const staticUrl10: string = import.meta.env.VITE_APP_STATIC_PATH10;
/**
 * 参数处理
 * @param {*} params  参数
 */

export const tansParams = (params: any) => {
  let result = '';
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    const part = encodeURIComponent(propName) + '=';
    if (value !== null && value !== '' && typeof value !== 'undefined') {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== '' && typeof value[key] !== 'undefined') {
            const params = propName + '[' + key + ']';
            const subPart = encodeURIComponent(params) + '=';
            result += subPart + encodeURIComponent(value[key]) + '&';
          }
        }
      } else {
        result += part + encodeURIComponent(value) + '&';
      }
    }
  }
  return result;
};

// 验证是否为blob格式
export const blobValidate = (data: any) => {
  return data.type !== 'application/json';
};

/**
 * @description 获取当前时区
 * @returns {String}
 */
export function getClientTimeZone(): string {
  const tz = new Date().getTimezoneOffset();
  const hoursOffset = Math.abs(tz / 60);
  const sign = tz < 0 ? '+' : '-';
  return `GMT${tz === 0 ? '' : sign + hoursOffset}`;
}

/**
 * @description 获取系统分辨率
 * @returns {String}
 */
export function getScreenResolution(): string {
  return `${window.screen.width} * ${window.screen.height}`;
}

/**
 * @description 防抖方法
 * @param {func} 要延迟执行的函数。
 * @param {wait } 延迟的时间（毫秒）
 */
export function debounce<T extends (...args: any[]) => any>(func: T, wait: number = 300): (...args: Parameters<T>) => void {
  let timer: ReturnType<typeof setTimeout> | undefined;
  return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}

/*
    睡眠 
    @params: numberMillis 睡眠时间
*/
export const sleep = function (numberMillis: number) {
  let now = new Date();
  const exitTime = now.getTime() + numberMillis;
  while (true) {
    now = new Date();
    if (now.getTime() > exitTime) return;
  }
};
// 节流
type AnyFunction = (...args: any[]) => any;
export const throttle = (fn: AnyFunction, delay: number = 200): AnyFunction => {
  let enterTime = 0;
  let gapTime = delay;
  return (...args: any[]) => {
    const backTime = new Date().getTime();
    if (backTime - enterTime > gapTime) {
      fn.apply(this, args);
      enterTime = backTime;
    }
  };
};

/**
 * 深拷贝
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone<T>(source: T): T {
  if (!source || typeof source !== 'object') {
    throw new Error('Invalid arguments for deepClone');
  }

  const targetObj: T = (Array.isArray(source) ? [] : {}) as T;

  Object.keys(source).forEach(key => {
    const value = (source as any)[key];
    if (value && typeof value === 'object') {
      (targetObj as any)[key] = deepClone(value);
    } else {
      (targetObj as any)[key] = value;
    }
  });

  return targetObj;
}

/**
 * 表格时间格式化
 */
export const formatDate = (cellValue: string) => {
  if (cellValue == null || cellValue == '') return '';
  const date = new Date(cellValue);
  const year = date.getFullYear();
  const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
  const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
  const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
  const seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
};
// 日期格式化
export function parseTime(time: any, pattern?: string) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    } else if (typeof time === 'string') {
      time = time
        .replace(new RegExp(/-/gm), '/')
        .replace('T', ' ')
        .replace(new RegExp(/\.[\d]{3}/gm), '');
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj: { [key: string]: any } = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  return format.replace(/{(y|m|d|h|i|s|a)+}/g, (result: string, key: string) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
}

/**
 * @description 格式化 分钟
 * @param | DHM | HM
 * @return | 4d 4h 4min | 4h 4min
 */

export const minutesToDHM = (minutes: number, format?: 'DHM' | 'HM') => {
  if (!format || format === 'DHM') {
    const days = Math.floor(minutes / 1440);
    const hours = Math.floor((minutes % 1440) / 60);
    const min = minutes % 60;

    let result = [];
    if (days > 0) result.push(`${days}d`);
    if (hours > 0) result.push(`${hours}h`);
    if (min > 0 || result.length === 0) result.push(`${min}min`);
    return result.join(' ');
  } else if (format === 'HM') {
    // 计算小时
    const hours = Math.floor(minutes / 60);
    const min = minutes % 60;
    let result = [];
    if (hours > 0) result.push(`${hours}h`);
    if (min > 0 || result.length === 0) result.push(`${min}min`);
    // 格式化输出为时分秒
    return result.join(' ');
  }
};

/**
 * @description 格式化 秒
 * @param | DHM | HM
 * @return | 4d 4h 4min | 4h 4min
 */
export const secondsToDHM = (seconds: number, format?: 'DHM' | 'HM') => {
  if (!format || format === 'DHM') {
    const days = Math.floor(seconds / 86400); // 1天=86400秒
    const hours = Math.floor((seconds % 86400) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);

    const result = [];
    if (days > 0) result.push(`${days}d`);
    if (hours > 0) result.push(`${hours}h`);
    if (minutes > 0 || result.length === 0) result.push(`${minutes}min`);

    // 处理全零的情况（如输入0秒）
    return result.join(' ');
  } else if (format === 'HM') {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);

    // 格式化为"X小时Y分钟"
    let result = [];
    if (hours > 0) result.push(`${hours}h`);
    if (minutes > 0 || result.length === 0) result.push(`${minutes}min`);

    return result.join(' '); // 处理0秒的情况
  }
};

// 保留两位小数，超出两位完整显示小数
export const str2decimal = (num: string) => {
  // 处理数值为字符串，避免科学计数法
  let str = Number(num).toString();
  if (str.includes('e')) {
    // 转换科学计数法为普通格式
    str = Number(num).toFixed(20);
  }

  // 分割整数和小数部分
  const parts = str.split('.');
  const integerPart = parts[0];
  let decimalPart = parts.length > 1 ? parts[1].replace(/0+$/, '') : '';

  // 根据小数位数处理
  if (decimalPart.length === 0) {
    return `${integerPart}.00`;
  } else if (decimalPart.length <= 2) {
    return `${integerPart}.${decimalPart.padEnd(2, '0')}`;
  } else {
    return `${integerPart}.${decimalPart}`;
  }
};

/**
 * Luhn 算法验证
 */

export const isValidLuhn = (number: string): boolean => {
  let digit,
    sum = 0,
    _ref1 = number.split('').reverse();
  for (let n = 0, _j = 0, _len1 = _ref1.length; _j < _len1; n = ++_j) {
    digit = _ref1[n];
    digit = +digit;
    if (n % 2) {
      digit *= 2;
      if (digit < 10) {
        sum += digit;
      } else {
        sum += digit - 9;
      }
    } else {
      sum += digit;
    }
  }
  return sum % 10 === 0;
};

export const businessList = [
  { id: '1820693954263351300', name: 'Coins' }, //金币
  { id: '1820693954263351301', name: 'Items' }, //装备
  { id: '1820693954263351302', name: 'Accounts' }, //账号
  // { id: '1820693954263351303', name: 'Coaching' }, //陪玩
  { id: '1820693954263351304', name: 'Boosting' }, //代练
  { id: '1820693954263351305', name: 'Top Up' }, //直充
  { id: '1820693954263351306', name: 'Game Points' },
  { id: '1820693954263351307', name: 'Gift Cards' }, //礼品卡
  { id: '1820693954263351308', name: 'Subscriptions' }, //订阅
  { id: '1820693954263351309', name: 'Software' }, //软件
  { id: '1820693954263351310', name: 'Video Games' },
  { id: '1848553943624232961', name: 'Fifa Coins' }, //fifa金币
  { id: '1848554129733890049', name: 'Fifa Player' }, //fifa球员
  // { id: '1848554356402466818', name: 'Fifa SBC' }, //fifa SBC
  // { id: '1848554567304654850', name: 'Fifa Ultimate-team' }, //fifa 球队
  { id: '1876446768564609026', name: 'Fifa Squad' } //FIFA Squad
];

// 业务id转化业务名称
export const transformBusinessName = (businessId?: string) => {
  const businessList1 = [
    { id: '1820693954263351300', name: 'Coins' }, //金币
    { id: '1820693954263351301', name: 'Items' }, //装备
    { id: '1820693954263351302', name: 'Accounts' }, //账号
    // { id: '1820693954263351303', name: 'Coaching' }, //陪玩
    { id: '1820693954263351304', name: 'Boosting' }, //代练
    { id: '1820693954263351305', name: 'Top Up' }, //直充
    { id: '1820693954263351306', name: 'Game Points' },
    { id: '1820693954263351307', name: 'Gift Cards' }, //礼品卡
    { id: '1820693954263351308', name: 'Subscriptions' }, //订阅
    { id: '1820693954263351309', name: 'Software' }, //软件
    { id: '1820693954263351310', name: 'Video Games' },
    { id: '1848553943624232961', name: 'Fifa Coins' }, //fifa金币
    { id: '1848554129733890049', name: 'Fifa Player' }, //fifa球员
    // { id: '1848554356402466818', name: 'Fifa SBC' }, //fifa SBC
    // { id: '1848554567304654850', name: 'Fifa Ultimate-team' }, //fifa 球队
    { id: '1876446768564609026', name: 'Fifa Squad' } //FIFA Squad
  ];
  const business = businessList1.find(item => item.id === businessId);
  return business?.name || '';
};
